var React = require('react');

function IconCheckCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M14 2a12 12 0 1 0 12 12A12 12 0 0 0 14 2zm0 21.6a9.6 9.6 0 1 1 9.6-9.6 9.613 9.613 0 0 1-9.6 9.6zm5.508-14.9L11.6 16.6l-3.108-3.1L6.8 15.2l4.8 4.8 9.6-9.6z","transform":"translate(-2 -2)"}));
}

IconCheckCircle.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconCheckCircle;

IconCheckCircle.default = IconCheckCircle;
